export default {
  elAftaleNoFee: 'El-aftale uden leverandørgebyr',

  // Marketing common
  getMoreTitle: 'Få mere med',
  saveUp30: 'Spar op til 30%',
  freeSolar: 'Gratis solcelleaftale',
  onlyInDenmark: '0 kr. leverandørgebyr',
  enkelApp: 'enkel app',
  aiCharging: 'AI-styret opladning',
  flexibleBilling: 'Fleksibel afregning',
  acontoOrConsumption: 'Aconto eller forbrugsafregning',
  noElPlanSelected: 'Ingen el-aftale valgt',
  paymentNotice: 'Du kan bestille ladeboks uden el-aftale, men du vil ikke kunne bruge Saving Mode uden en el-aftale fra enkel.',
};